import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { Language } from '@mui/icons-material';

import OuterLink from '../OuterLink';
import { colors } from '../../constants/styleConstants';
import { useTranslation } from '../../src/i18n';
import { TP } from 'constants/index';
import { addProtocolIfNeed } from '../../utils/common';

const useStyles = makeStyles()({
  websiteLinkContainer: {
    display: 'flex',
  },
  websiteLink: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: colors.websiteLinkColor,
    fontSize: '13px',
    background: colors.websiteLinkColorBg,
    borderRadius: '20px',
    padding: '9px 11px',
    minWidth: '130px',
    lineHeight: 1,
    cursor: 'pointer',
    '&:active': {
      opacity: 0.6,
    },
  },
  websiteIcon: {
    marginRight: 8,
    width: 20,
    height: 20,
    '& > svg': {
      width: 20,
      height: 20,
    },
  },
});

const VisitWebsiteLink = ({ className, linkText, href }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return href && (
    <div className={cx(classes.websiteLinkContainer, className)}>
      <OuterLink className={classes.websiteLink} href={addProtocolIfNeed(href)}>
        <span className={classes.websiteIcon}>
          <Language style={{ color: colors.black, opacity: 0.5 }} />
        </span>
        {t(linkText)}
      </OuterLink>
    </div>
  );
};

VisitWebsiteLink.propTypes = {
  className: PropTypes.string,
  linkText: PropTypes.string,
  href: PropTypes.string.isRequired,
};

VisitWebsiteLink.defaultProps = {
  linkText: `${TP}.FN_VIEW_WEBSITE`,
};

export default VisitWebsiteLink;
